import "./src/styles/global.css"
import { trackPageView } from "./src/lib/analytics"

export const onRouteUpdate = ({ location }) => {
  trackPageView(location.pathname + location.search)
}
